import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import CSSZSickLeavePatientAddressPickerItem from './CSSZSickLeavePatientAddressPickerItem';
import styles from './CSSZSickLeavePatientAddressesPicker.module.scss';
import { useEffectAsync } from '../../../../helpers';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useLoading from '../../../Base/Hooks/useLoading';
import { CsszPatientAddressRow } from '../../Helpers/csszRegistryPatientAddresses.helper';

interface Props {
	userId: string;
	onSelect: (item: CsszPatientAddressRow) => void;
	onClose: () => void;
}

const CSSZSickLeavePatientAddressesPicker: React.FC<Props> = ({
	userId,
	onSelect,
	onClose,
}) => {
	const [rows, setRows] = useState<CsszPatientAddressRow[]>([]);
	const { setIsLoading, isLoading, RenderLoading } = useLoading(true);
	const { displayError } = useApiClient();

	useEffectAsync(async () => {
		setIsLoading(true);
		try {
			const response = await apiClient.get(`/cssz/${userId}/adresy`);
			if (response.status === 200) {
				const addresses = Array.isArray(response.data)
					? (response.data as CsszPatientAddressRow[])
					: [];
				setRows(addresses);
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	}, [userId]);

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			{rows.map((item, index) => (
				<CSSZSickLeavePatientAddressPickerItem
					key={index}
					item={item}
					onSelect={onSelect}
				/>
			))}
			<LinkButton
				title='component.CSSZSickLeaveCertificateWrapper.manualEntryInstead'
				onClick={onClose}
				theme={Theme.BLUE}
			/>
		</div>
	);
};

export default CSSZSickLeavePatientAddressesPicker;
